import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PAY_URL } from "../../../BaseURL";
import toast from "react-hot-toast";

// Thunk to fetch categories
export const getAdminCategory = createAsyncThunk(
  '/category/getAdminCategory',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${PAY_URL}/user/get-admin-category`, {
        headers: { Authorization: "Bearer " + localStorage.getItem('PAY_USER_TOKEN') }
      });

      if (response.data.success === true) {
        return response.data.data; // <-- array of categories
      } else {
        return rejectWithValue(response.data.message);
      }
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || "Something went wrong");
    }
  }
);

const getAdminCategorySlice = createSlice({
  name: "getAdminCategory",
  initialState: {
    categories: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAdminCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdminCategory.fulfilled, (state, action) => {
        state.categories = Array.isArray(action.payload) ? action.payload : [];
        state.loading = false;
        state.error = null;
      })
      .addCase(getAdminCategory.rejected, (state, action) => {
        state.categories = [];
        state.loading = false;
        state.error = action.payload || action.error.message;
        toast.error(state.error);
      });
  }
});

export default getAdminCategorySlice.reducer;
